// extracted by mini-css-extract-plugin
export default {"diffHeaderWrapper":"Diff-module__diffHeaderWrapper--J03RC"};